module.exports = __webpack_public_path__ + "media/images/pic/anime/laptop-66d817f58d08c29bdb664056f1fa3d5b.svg";